import moment from "moment";
import Loader from "@/components/loader/Loader.vue";

export default {
  name: "ResidentsAdHocActivitiesReport",
  data() {
    return {
      search: '',
      residents: [],
      period: "month",
      startDate: moment().subtract(1, "month").toISOString().substring(0, 10),
      endDate: moment().toISOString().substring(0, 10),
      loading: false,
      flexHeight: 250,
      picker: {
        start: false,
        end: false
      },
      periods: [
        { title: this.$i18n.messages[this.$i18n.locale]["GeneralTranslations.Week"], value: "week" },
        { title: this.$i18n.messages[this.$i18n.locale]["GeneralTranslations.Month"], value: "month" },
        { title: this.$i18n.messages[this.$i18n.locale]["GeneralTranslations.Year"], value: "year" }
      ],
      headers: [
        { text: this.$t('GeneralTranslations.Resident'), value: "name" },
        { text: this.$t('Settings.ActivitiesManager.Activities'), value: "activitiesCount" },
        { text: this.$t('Reports.ActivitiesReport.EventsPerDay'), value: "activitiesPerDay" },
      ],
      jsonFields: {
        "Resident": "name",
        "Events": "activitiesCount",
        "Events per Day": "activitiesPerDay",
      },
    }
  },
  components: {
    Loader
  },
  computed: {
    facility() {
      return this.$store.state.facilityModule.selectedFacility
    },
    report() {
      return this.$store.state.adHocActivitiesModule.residentsAdHocActivitiesReportData;
    },
    formattedStartDate() {
      return moment(this.startDate).format(this.facility.dateFormat)
    },
    formattedEndDate() {
      return moment(this.endDate).format(this.facility.dateFormat)
    },
    formattedSelectedDateRange() {
      return `${moment(this.startDate).format(this.facility.dateFormat)} - ${moment(this.endDate).format(this.facility.dateFormat)}`
    }
  },
  created() {
    this.getActivitiesByDates()
  },
  methods: {
    routeToBack() {
      this.$router.push("/reports/adHocActivitiesReport");
    },
    handleClickResident(resident) {
      this.$router.push(`/reports/adHocActivitiesReport/${resident.id}`);
    },
    async getActivitiesByDates() {
      this.loading = true

      await this.$store.dispatch("getResidentsAdhocActivitiesReportData", {
        startDate: moment(this.startDate).startOf('day').toDate(),
        endDate: moment(this.endDate).endOf('day').toDate()
      });

      this.loading = false
      this.residents = this.report.residents

    },
    handleChangePeriod(period) {
      this.startDate = moment()
        .subtract(1, period)
        .toISOString()
        .substring(0, 10);

      this.endDate = moment()
        .toISOString()
        .substring(0, 10);

      //reload report
      this.getActivitiesByDates()
    }
  }

}
